import { DirectCampaignState, DirectCampaignStatus } from '../../types';

const stateTextMap = {
    OFF: 'Выключена',
    ON: 'Включена',
    ARCHIVED: 'Архивирована',
    SUSPENDED: 'Приостановлена',
    UNKNOWN: 'Неизвестно',
    CONVERTED: 'Конвертирована',
    ENDED: 'Завершена',
};

const statusTextMap = {
    DRAFT: 'Черновик',
    ACCEPTED: 'Опубликована',
    MODERATION: 'На модерации',
    REJECTED: 'Отклонена',
    UNKNOWN: 'Неизвестно',
};

export const getDirectCompanyStatusText = (
    status: DirectCampaignStatus,
    state: DirectCampaignState,
) => {
    // для запущенной кампании показываем состояние
    if (status === 'ACCEPTED') {
        return stateTextMap[state];
    }

    // иначе показываем на каком этапе запуска находится
    return statusTextMap[status];
};
